import React, { useState } from 'react';
import { Typography, Box, SxProps, Theme } from "@mui/material";
import ArrowForwardFilled from "@mui/icons-material/ArrowForward";

interface Props {
    isWithoutNavi?: boolean;
    isWithoutTopNavi?: boolean;
}

const getBoxStyles = (isWithoutTopNavi: boolean, skipLinksFocused: boolean): SxProps<Theme> => ({
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 1200,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: '#fff',
    padding: isWithoutTopNavi && skipLinksFocused ? '10px' : 'inherit',
    '& .skip-link': {
        display: 'block',
        padding: 0,
        margin: '12px',
        background: '#fff',
        textDecoration: 'none',
        fontWeight: 'bold',
        position: 'static',
    },
    '& .skip-link:focus': {
        outlineOffset: '4px',
    },
    '& .skip-link:not(:focus)': {
        position: 'absolute',
        left: '-9999px',
    }
});


export const SkipLinks: React.FC<Props> = ({
                                                  isWithoutNavi,
                                                  isWithoutTopNavi
                                              }) => {
    const [skipLinksFocused, setSkipLinksFocused] = useState(false);

    const handleFocus = () => {
        setSkipLinksFocused(true);
    };

    const handleBlur = () => {
        setSkipLinksFocused(false);
    };

    const renderLink = (href: string, label: string, key: string) => (
        <a
            key={key}
            href={href}
            className="skip-link"
            onFocus={handleFocus}
            onBlur={handleBlur}
        >
            <Typography
                color="primary.main"
                variant="linkLabel"
                sx={{ fontWeight: 700, fontSize: '16px' }}
            >
                <ArrowForwardFilled sx={{ width: '0.9em', height: '0.9em', mb: '-5px', mr: '8px' }} />
                {label}
            </Typography>
        </a>
    );

    return (
        <Box
            component="nav"
            aria-label="Sprunglinks"
            sx={getBoxStyles(isWithoutTopNavi || false, skipLinksFocused)}
        >
            {!isWithoutNavi && renderLink("#navigation", "Zur Hauptnavigation springen", "nav")}
            {renderLink("#main", "Zum Seiteninhalt springen", "main")}
            {renderLink("#footer", "Zum Ende der Seite springen", "footer")}
        </Box>
    );
};
